module.exports = __webpack_public_path__ + "KaTeX_Size1-Regular.84d89c68.woff";